import { VisualPermissionResponse } from 'users/interfaces/visual-permissions.interface';
import { CurrentUserInterface } from './current-user.interface';

export interface CurrentSupplierUserInterface extends CurrentUserInterface {
    supplierId: string;
    companyName: string;
    hasPreviousUserGroup: boolean;
    termsAndConditions: string;
    termsAndConditionsAcceptanceDate: string;
    listingAccessGroups: [
        {
            id: string;
            name: string;
            description: string;
            supplierId: string;
            companyName: string;
            listingAccesses: [
                {
                    id: string;
                    accessIdValue: string;
                    accessType: string;
                    displayName: string;
                },
            ];
        },
    ];
    hasVisualsUIEnabled?: boolean;
    internalPermissions: InternalPermissions[];
    resourcePermissions: ResourcePermissions[];
    visualPermissions: VisualPermissionResponse[];
    hasAccessToIce: boolean;
    hasAccessToDAL: boolean;
    autoShorteningEnabled: boolean;
    autoTranslationEnabled: boolean;
    imageEditingEnabled: boolean;
}

export interface InternalPermissions {
    id: string;
    accessType: string;
    permissionOwner: string;
    permissionAccessZone: string;
}

export interface ResourcePermissions {
    id: string;
    resourceId: string;
    accessType: string;
    userGroupId: string;
}

export const isCurrentSupplierUser = (user: CurrentUserInterface): user is CurrentSupplierUserInterface => {
    return (
        'hasAccessToIce' in user &&
        'hasAccessToDAL' in user &&
        typeof (user as CurrentSupplierUserInterface).hasAccessToIce === 'boolean' &&
        typeof (user as CurrentSupplierUserInterface).hasAccessToDAL === 'boolean'
    );
};
